import React from 'react'
import { Box, Grid, Typography, Skeleton } from '@mui/material'
import { CardSeeker, IconSeeker } from '@ui-seeker/core'
import { summaryData, tableData, isLoadingTable } from './@signals'

const StatCard = ({ title, value, icon, color, isLoading }) => (
    <CardSeeker sx={{ p: 2, height: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    {title}
                </Typography>
                {isLoading ? (
                    <Skeleton width={80} height={40} />
                ) : (
                    <Typography variant="h4" sx={{ fontWeight: 600, color: `${color}.main` }}>
                        {typeof value === 'number' ? value.toLocaleString() : value}
                    </Typography>
                )}
            </Box>
            <Box
                sx={{
                    p: 1,
                    borderRadius: 1,
                    bgcolor: `${color}.lighter`,
                    color: `${color}.dark`
                }}
            >
                <IconSeeker icon={icon} size="lg" />
            </Box>
        </Box>
    </CardSeeker>
)

export default function SummaryCards() {
    const summary = summaryData.value
    const data = tableData.value
    const loading = isLoadingTable.value

    // Calculate total MAPs from table data
    const totalMaps = data.reduce((acc, user) => acc + Number(user.map_count || 0), 0)

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    title="Active Users"
                    value={summary?.total_users || 0}
                    icon="users"
                    color="primary"
                    isLoading={loading}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    title="Total Actions"
                    value={summary?.total_actions || 0}
                    icon="chart-line"
                    color="success"
                    isLoading={loading}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    title="Total MAPs"
                    value={totalMaps}
                    icon="circle-plus"
                    color="info"
                    isLoading={loading}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <StatCard
                    title="Avg Rate/Hour"
                    value={summary?.avg_rate_per_hour || 0}
                    icon="gauge-high"
                    color="warning"
                    isLoading={loading}
                />
            </Grid>
        </Grid>
    )
}
